import { Dialog, Stack, Typography, DialogActions, Button, IconButton, TextField, useTheme, MenuItem } from '@mui/material';
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import { Formik, Form, FieldArray } from 'formik';
import { buttonStyle2, buttonStyle3, dialogButtonCancel } from '../../../../utils/commonStyle';
import appapi from '../../../../api/apiClient';
import { showmessage } from '../../../../utils/toastr';
import { setLoading } from '../../../../redux/features/appSlice';
import FormTextField from '../../../../components/FormTextField';
import ModalHeader from '../../../../components/ModalHeader';
import { Verified } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import { matchIsValidTel } from 'mui-tel-input'
import PhoneTextField from '../../../../components/PhoneTextField';

const validationSchema = yup.object({
  contact: yup.array().of(
    yup.object().shape({
      contactName: yup.string('Name').min(3, 'Name should be atleast 3 characters').max(50, 'Maximum Character Limit 50').required(' '),
      contactEmail: yup
        .string('Email ID')
        .matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'Email is Invalid')
        .trim()
        .nullable()
        .required(' '),
      phone: yup
        .string('Phone Number').required().test('is-valid-number', 'Mobile Number is Invalid', value => {
          if(value) {
            return matchIsValidTel(value)
          }
          
          return false;
        }),
      contactDesignation: yup.string('Contact Designation').min(3, 'Designation should be atleast 3 characters').max(50, 'Maximum Character Limit 50').required(' '),
    }),
  ),
});

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100%)',
    // overflow: 'hidden'
  },
};

export default function EditContactDialog({ modelOpen, onModelHandleClose, verifierId, contacts }) {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();

  const { user, userId } = useSelector((state) => state.auth);

  const handleEditVerifierContact = async (values) => {
    const arr = values.contact.map((res) => {
      return {
        ...res,
        contactId: res._id || null,
        operation: res._id ? 'update' : 'create',
      };
    });
    const ids = arr.filter((res) => res?._id).map((res) => res._id);
    for (const c of contacts) {
      if (!ids.includes(c._id)) {
        arr.push({
          ...c,
          contactId: c._id,
          operation: 'delete',
        });
      }
    }

    dispatch(setLoading(true));
    const response = await appapi.put(`/verifier/contacts/${verifierId}`, {
      contacts: arr,
      adminId: userId,
    });
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true);
        showmessage(data.message);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      // TransitionComponent={Transition}
      PaperProps={{ sx: { position: 'fixed', top: 0, right: 0, m: 0 } }}
    >
      <ModalHeader
        label={'EDIT CONTACT'}
        onClose={() => onModelHandleClose(false)}
      />
      <Stack
        style={{ backgroundColor: theme.palette.border.main, height: '2px', opacity: 0.5 }}
        className="mx-[25px]"
      />
      <Stack
        style={{ backgroundColor: 'white' }}
        flex={1}
      >
        <Formik
          innerRef={formRef}
          enableReinitialize={true}
          autoComplete="off"
          initialValues={{
            contact:
              contacts && contacts.length > 0
                ? contacts
                : [
                  {
                    contactId: '',
                    contactName: '',
                    contactDesignation: '',
                    contactEmail: '',
                    contactNumber: '',
                    phone: '',
                    phoneCode: '',
                  },
                ],
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleEditVerifierContact(values);
          }}
        >
          {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue, handleSubmit, isSubmitting }) => (
            <Form autoComplete="off">
              <FieldArray
                name="contact"
                render={(arrayHelpers) => (
                  <>
                    <Stack
                      direction={'row'}
                      alignItems={'center'}
                      justifyContent={'space-between'}
                      style={{ backgroundColor: 'FFFFFF', marginTop: '10px' }}
                    >
                      <Typography
                        style={{ marginLeft: '25px' }}
                        className="fw-medium fs-18 ff-Roboto"
                        color={'#14285A'}
                      >
                        Contacts
                      </Typography>
                      <Stack>
                        <Button
                          className="!mr-[16px] "
                          sx={[buttonStyle3, { width: '125px', height: '40px', fontSize: '12px' }]}
                          style={{
                            backgroundColor: theme.palette.primary.dark,
                            color: 'rgba(255, 255, 255, 1)',
                          }}
                          onClick={() => {
                            arrayHelpers.push({
                              contactId: '',
                              contactName: '',
                              contactDesignation: '',
                              contactEmail: '',
                              contactNumber: '',
                              phone: '',
                              phoneCode: '',
                            });
                          }}
                          variant="contained"
                          startIcon={<AddIcon />}
                        >
                          Add More
                        </Button>
                      </Stack>
                    </Stack>
                    <Stack
                      style={{ backgroundColor: theme.palette.border.main, height: '1px', marginBottom: '10px', marginTop: '10px', opacity: 0.5 }}
                      className="mx-[25px]"
                    />

                    {values?.contact?.map((data, index) => (
                      <Stack className="mx-[25px]">
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          justifyContent={'space-between'}
                        >
                          <Typography
                            className="fw-medium fs-14 ff-Roboto"
                            color={'#14285A'}
                            style={{ marginBottom: '10px' }}
                          >
                            Contact person {index + 1}
                          </Typography>
                          {values?.contact?.length > 1 ? (
                            <Button
                              direction={'row'}
                              alignItems={'center'}
                              onClick={() => {
                                // removedFields.push({ renewalDocumentsId: values.contact[index].renewalDocumentsId });
                                arrayHelpers.remove(index);
                              }}
                              style={{ marginRight: '20px', marginBottom: '10px' }}
                              sx={{
                                color: '#F02323',
                                '&:hover': {
                                  backgroundColor: theme.palette.grayBg.secondary,
                                },
                              }}
                            >
                              <ClearIcon style={{ transform: 'scale(0.643)' }} />
                              <Typography
                                className="fw-medium fs-14 ff-Roboto"
                                color={'#F02323'}
                              >
                                REMOVE
                              </Typography>
                            </Button>
                          ) : null}
                        </Stack>
                        <Stack
                          className="!flex"
                          sx={{
                            justifyContent: 'space-between',
                          }}
                        >
                          <FormTextField
                            name={`contact.${index}.contactName`}
                            outlineLabel={'Name'}
                            requiredMark={true}
                            inputProps={{ maxLength: 51 }}
                          />
                          <FormTextField
                            name={`contact.${index}.contactDesignation`}
                            outlineLabel={'Designation'}
                            requiredMark={true}
                            inputProps={{ maxLength: 51 }}
                          />
                          <FormTextField
                            name={`contact.${index}.contactEmail`}
                            outlineLabel={'Email Id'}
                            requiredMark={true}
                            inputProps={{ maxLength: 50 }}
                            lowerCase={true}
                          />
                           <PhoneTextField required variant="outlined" label="Phone No" name={`contact.${index}.phone`} name2={`contact.${index}.contactNumber`} name3={`contact.${index}.phoneCode`} />
                        </Stack>
                      </Stack>
                    ))}
                  </>
                )}
              />

              <DialogActions
                style={{
                  height: '66px',
                  padding: '0',
                  marginTop: '20px',
                  marginRight: '20px',
                }}
                className="!mt-[200px] h-[66px] !justify-end p-[0px]"
              >
                <Button
                  sx={[
                    dialogButtonCancel,
                    {
                      color: theme.palette.primary.main,
                      borderColor: '#14285A33',
                      backgroundColor: '#14285A1A',
                      '&:hover': {
                        // backgroundColor: theme.palette.secondary.main,
                        // color: theme.palette.background.main,
                        // borderColor: theme.palette.secondary.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', marginLeft: '80px', height: '40px' }}
                  variant="outlined"
                  onClick={() => {
                    onModelHandleClose(true);
                    //   setConfirmVal('');
                  }}
                >
                  CANCEL
                </Button>
                <Button
                  sx={[
                    buttonStyle2,
                    {
                      color: theme.palette.background.main,
                      backgroundColor: theme.palette.primary.dark,
                      '&:hover': {
                        // backgroundColor: theme.palette.secondary.main,
                        // color: theme.palette.background.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', height: '40px' }}
                  disabled={!(dirty && isValid)}
                  type="submit"
                  variant="contained"
                >
                  SAVE
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Stack>
    </Dialog>
  );
}
